// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2nCFD","center":"styles_center__enLUD"};